module.exports = __webpack_public_path__ + "static/media/Saptham.0d8d82e8.svg";